import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

import { LANG_STORAGE_KEY, Language } from '@/shared/config';
import { languageInstall } from '@/shared/libs';
import { defaultEN, defaultRU } from '@shared/locales';

export const resources = {
  en: {
    translation: defaultEN,
  },
  ru: {
    translation: defaultRU,
  },
} as const;

i18n.use(initReactI18next).init({
  defaultNS: 'translation',
  detection: {
    lookupLocalStorage: LANG_STORAGE_KEY,
  },
  fallbackLng: Language.Russian,
  interpolation: {
    escapeValue: false,
  },
  lng: languageInstall(),
  ns: ['translation'],
  resources,
  saveMissing: true,
  saveMissingTo: 'all',
});

i18n.on('languageChanged', (lng) => {
  localStorage.setItem(LANG_STORAGE_KEY, lng);
});

export { default } from 'i18next';
